/** Hindi: questions the worker's agent asked and where each answer came from. */
export const ask = {
    "ask.by_theirs": "{name} के एजेंट का सवाल",
    "ask.by_mine": "आपके एजेंट का सवाल",
    "ask.standard": "सामान्य सवाल",
    "ask.from_memory": "आपके पिछले कामों से",
    "ask.from_words": "आपकी कही बात से",
    "ask.skip": "छोड़ें",
    "ask.skipped": "छोड़ दिया",
    "ask.number": "एक संख्या",
    "ask.memory_offer": "आपके पिछले कामों से: {value}। यही भेजें?",
    "ask.memory_old": "एक साल पहले यह पता था: {value}। क्या अब भी सही है?",
    "ask.change": "बदलें",
};
//# sourceMappingURL=ask.js.map